import script from "./MileStones.vue?vue&type=script&setup=true&lang=ts"
export * from "./MileStones.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__